import React from "react";
import { ConfirmDialog } from "@outpave/ds";
import { HugeiconsIcon } from "@hugeicons/react";
import { WifiDisconnected02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Stack } from "components/layout/reusableLayouts";
import Typography from "@mui/material/Typography";

interface ExternalAccountDisconnectedPopoverProps {
  open: boolean;
  handleClose: (accepted: boolean) => void;
}

const ExternalAccountDisconnectedPopover: React.FC<
  ExternalAccountDisconnectedPopoverProps
> = ({ open, handleClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ConfirmDialog
      open={open}
      tone="primary"
      title={t("External Account Disconnected")}
      icon={<HugeiconsIcon icon={WifiDisconnected02Icon} size={20} />}
      message={
        <Stack gap="var(--space-4)">
          <Typography variant="body2">
            {t("ExternalAccountDisconnectedMessage1")}
          </Typography>
          <Typography variant="body2">
            {t("ExternalAccountDisconnectedMessage2")}
          </Typography>
        </Stack>
      }
      cancelLabel={t("Cancel")}
      confirmLabel={t("Reconnect")}
      onCancel={() => handleClose(false)}
      onConfirm={() => navigate("/admin/settings/linked-accounts/")}
      labels={{ close: t("Close") }}
    />
  );
};

export default ExternalAccountDisconnectedPopover;
